
document.querySelectorAll(".collection-list.swiper").forEach((collectionList) => {
  // Show 4 across on wide screens when there are more than 3 items
  const hasFourUp = collectionList.querySelectorAll(".swiper-slide").length > 3;

  new Swiper(collectionList, {
    loop: false,
    grabCursor: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1100: {
        slidesPerView: hasFourUp ? 4 : 3,
      },
      990: {
        slidesPerView: 3,
      },
      750: {
        slidesPerView: 2,
      },
      300: {
        slidesPerView: 1.5,
        centeredSlides: true,
      },
    },
  });
});
